import { breadcrumb } from './breadcrumb';

export const referral = {
  breadcrumb,

  description:
    'Anda dapat menerima bonus untuk pelanggan Anda. Untuk setiap pengguna baru yang mendaftar menggunakan tautan Anda, Anda akan menerima hingga {persen}% dari pengeluaran mereka.',

  button: {
    create_request: 'Withdraw Dana'
  },

  user: {
    field: {
      email: 'E-mail',
      created_at: 'Tanggal registrasi'
    }
  },

  profit: {
    field: {
      date_from: 'Waktu star',
      date_to: 'Waktu berakhir',
      referral: 'Referral',
      amount: 'Jumlah'
    }
  },

  request: {
    type: {
      internal: 'Jumlah dana di Zorra',
      external: 'Withdraw dana Saldo'
    },

    status: {
      pending: 'Batal',
      success: 'Sukses',
      rejected: 'Ditolak',
      failed: 'Gagal'
    },

    field: {
      amount: 'Jumlah'
    },

    modal: {
      create: {
        content:
          'Saldo Anda {balance}. Anda dapat mengisi kembali saldo Zorra Anda atau membuat permintaan penarikan uang.'
      }
    }
  }
};
